import { InfoButton, CloseButton } from 'components/buttons'
import { SortControls } from './SortControls'
import { Facet } from './FacetControl/Types'
import { FacetControl } from './FacetControl'

interface FacetPanelProps {
  closePanel: any
  facets: Facet<any>[]
  initialOpenSection?: string
  onFilterChange: (facetKey: string, selectedOptions: any) => void
  onApplyFilters: () => void
  onClearFilters: () => void
  onSortChange: (sortValue: string) => void
  selectedFilters: any
  selectedSort?: string
}

export const FacetPanel = ({
  closePanel,
  facets,
  initialOpenSection,
  onFilterChange,
  onApplyFilters,
  onClearFilters,
  onSortChange,
  selectedFilters = {},
  selectedSort,
}: FacetPanelProps) => {
  return (
    <div style={{ height: '100%', overflow: 'hidden' }}>
      <CloseButton
        onClick={closePanel}
        className="mtl mll"
        style={{ float: 'left' }}
      />
      <div
        className="inline-block mbxl"
        style={{
          width: '100%',
          height: '100%',
          overflow: 'scroll',
          paddingBottom: '150px',
        }}
      >
        <SortControls
          isOpen={initialOpenSection === 'sort'}
          onSortChange={onSortChange}
          selectedSort={selectedSort}
        />
        {facets.map((facet: Facet<any>) => {
          return (
            <div key={facet.key}>
              <hr className="mvl" />
              <FacetControl
                facet={facet}
                isOpen={initialOpenSection === facet.key}
                onFilterChange={onFilterChange}
                selectedValues={selectedFilters[facet.key] || undefined}
              />
            </div>
          )
        })}
        <hr className="mvl" />
      </div>
      <div
        className="flex inline-block justify-center pal white-bg"
        style={{
          left: '0px',
          bottom: '0px',
          width: '100%',
          position: 'absolute',
          boxShadow: '#f2f2f2 0px -15px 20px 0px',
        }}
      >
        <InfoButton
          pill
          empty
          className="mrm"
          onClick={onClearFilters}
          style={{ minWidth: 116 }}
        >
          Clear All
        </InfoButton>
        <InfoButton pill block onClick={onApplyFilters}>
          Apply Filters
        </InfoButton>
      </div>
    </div>
  )
}
